import { AxButton, AxInput } from "@dynata/axiom3";
import Error from "../../../core/widgets/error";
import React, { useState } from "react";
import { useResetPassword } from "./hooks";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import paths from "paths";
import { ToastConfig } from "core/widgets/toastConfig.widget";

const EMPTY_EMAIL_ERROR = "Email required";

export const ResetPasswordPage: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | undefined>();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");

  const resetPassword = useResetPassword();

  const submit = async (e: any) => {
    e.preventDefault();
    if (!email.trim()) {
      setError(EMPTY_EMAIL_ERROR);
      return;
    }
    setLoading(true);

    resetPassword
      .mutateAsync(email)
      .then((_) => {
        toast.success(
          `A link will be sent to ${email} shortly, if it is associated with an active account`,
          ToastConfig,
        );
        navigate(`/${paths.open.LOGIN}`);
      })
      .catch((_) => {
        toast.error(
          "There was an error proccessing your request please try again later",
          ToastConfig,
        );
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <form className="form-wrapper">
        <div className="reset-fields">
          <AxInput
            prefix={<i className="fa-regular fa-envelope" />}
            onChange={(e: any) => {
              setError(undefined);
              if (!e.target.value.trim()) {
                setError(EMPTY_EMAIL_ERROR);
              }
              setEmail(e.target.value);
            }}
            onPressEnter={submit}
            placeholder="Email"
            value={email}
            size="large"
          />
          <Error error={error} />
        </div>
        <div className="reset-actions">
          <AxButton
            disabled={!email.trim() ? "disabled" : ""}
            loading={loading}
            onClick={submit}
            size="large"
          >
            Send Reset Password Email
          </AxButton>
          <AxButton
            onClick={() => navigate(`/${paths.open.LOGIN}`)}
            size="large"
            color="main"
            type="link"
          >
            Back to Login
          </AxButton>
        </div>
      </form>
    </>
  );
};
